import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import UIBody from "../../../components/ui/UIBody";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import useApiCallHooks from "../../../hooks/useApiCallHooks";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const ProgramDetailsPage = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const { slug } = useParams();
  const [programData, setProgramData] = useState({});
  const [formData, setFormData] = useState({
     first_name: "",
    last_name: "",
    email: "",
    mobile_no: "",
    program_id: "",
  });
const navigate=useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const cardsPerPage = 3;
  const roadmapRef = useRef(null);

  useEffect(() => {
    if (slug) {
      callAPI("get", `programs-details/${slug}`);
    }
  }, [slug]);

useEffect(() => {
  if (responce?.data && statusCode === 200) {
    const program = responce.data.program;
    setProgramData(responce.data);

    // Set program_id to the form data automatically
    if (program?.id) {
      setFormData((prev) => ({
        ...prev,
        program_id: program.id.toString(),
      }));
    }
  }
}, [responce, statusCode]);
useEffect(() => {
  if (statusCode === 201) {
    toast.success(`Student registered successfully! Your username is your 'email" and your password is your phone number`, {
  autoClose: 5000 // toast will disappear after 5 seconds
});

    // Optional: redirect or refresh data
   setTimeout(() => {
      navigate('/');
    }, 5000);
  }

 

}, [statusCode, navigate]);



  const roadmapItems = programData?.programRoadmap || [];
  const totalPages = Math.ceil(roadmapItems.length / cardsPerPage);
  const paginatedItems = roadmapItems.slice(
    (currentPage - 1) * cardsPerPage,
    currentPage * cardsPerPage
  );

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
    // You can add your form API call here
    callAPI('post','enroll-student-program',formData)
  };

  const roadmapVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        duration: 0.8,
        type: "spring",
        stiffness: 120,
      },
    }),
    hover: { y: -10, scale: 1.05, transition: { duration: 0.3 } },
    tap: { scale: 0.95 },
  };

  const steps = [
    {
      num: 1,
      title: "First Step",
      heading: "Create Your Account to Begin Learning Online",
      content: "Join our platform to unlock a world of knowledge...",
      img: "ragister.png",
    },
    {
      num: 2,
      title: "Second Step",
      heading: "Connect with Expert Mentors for Personalized Online Learning",
      content: "Start learning from experienced mentors...",
      img: "mentor-call.png",
    },
    {
      num: 3,
      title: "Third Step",
      heading: "Students Celebrate Achievement with Their Certificate Award",
      content: "Students receive their certificates...",
      img: "certificate.png",
    },
    {
      num: 4,
      title: "Last Step",
      heading: "Students Secure Their Dream Job with Certification",
      content: "Students receive their certificates...",
      img: "job.png",
    },
  ];

  return (
    <UIBody
    loading={loading}
      content={
        <div>
          {/* Program Details Section */}
          <motion.div
            className="row justify-content-center"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <section>
              <div className="container">
                <div className="card shadow program-details-section">
                  {programData?.program && (
                    <div className="card-body px-lg-5">
                      <h3 className="text-white">{programData.program.name}</h3>
                      <p className="text-white programe-content">
                        {programData.program.description}
                      </p>

                      <div className="d-flex gap-2 flex-wrap">
                        {programData.program.learning_points?.map((point, index) => (
                          <div
                            key={index}
                            className="program-details-mini-card py-2 px-4 rounded shadow"
                          >
                            <p className="m-0">
                              <b className="text-white">{index + 1}. {point}</b>
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </motion.div>

          {/* Roadmap and Form Section */}
          <section className="py-5" ref={roadmapRef}>
            <div className="container">
              <div className="row">
                {/* Roadmap Section */}
                <div className="col-lg-7">
                  <h2 className="text-center mb-4 fw-bold">Your Personalized Career Roadmap</h2>
                  <p className="text-center text-muted mb-5">
                    Here's your customized learning journey to become a Full Stack Developer
                  </p>

                  <div className="row justify-content-center">
                    {paginatedItems.map((point, index) => (
                      <motion.div
                        key={point.id}
                        className="col-lg-4 col-md-4 col-sm-6 mb-4"
                        custom={index}
                        initial="hidden"
                        whileInView="visible"
                        whileHover="hover"
                        whileTap="tap"
                        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
                        variants={roadmapVariants}
                      >
                        <div className="d-flex justify-content-center mb-4">
                          <div className="roadmap-icone">📘</div>
                        </div>
                        <div className="card shadow text-center roadmap-box">
                          <h5 className="fw-bold my-2">{point.name}</h5>
                          <ul className="list-unstyled text-start small h-200">
                            {point.topics?.map((topic, i) => (
                              <li key={i}>✅ {topic.name}</li>
                            ))}
                          </ul>
                        </div>
                      </motion.div>
                    ))}
                  </div>

                  {/* Pagination Arrows */}
                  <div className="d-flex justify-content-between mt-4">
                    <button
                      className="btn btn-outline-primary"
                      onClick={handlePrev}
                      disabled={currentPage === 1}
                    >
                      <FaArrowLeft size={20} />
                    </button>
                    <button
                      className="btn btn-outline-primary"
                      onClick={handleNext}
                      disabled={currentPage === totalPages}
                    >
                      <FaArrowRight size={20} />
                    </button>
                  </div>
                </div>

                {/* Form Section */}
                <div className="col-lg-5">
      <div className="singUp-wrap shadow">
        <h2 className="title">Create Your Account</h2>
        <form className="account__form" onSubmit={handleSubmit}>
          <div className="row gutter-20">
            <div className="col-md-6">
              <div className="form-grp">
                <label htmlFor="first-name">First Name</label>
                <input
                  type="text"
                  id="first-name"
                  placeholder="First Name"
                  onChange={(e) =>
                    setFormData({ ...formData, first_name: e.target.value })
                  }
                /> <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.first_name}
                </span>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-grp">
                <label htmlFor="last-name">Last Name</label>
                <input
                  type="text"
                  id="last-name"
                  placeholder="Last Name"
                  onChange={(e) =>
                    setFormData({ ...formData, last_name: e.target.value })
                  }
                
                /> <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.last_name}
</span>
              </div>
            </div>
          </div>
          <div className="form-grp">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              placeholder="Email"
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
            /><span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.email}</span>

          </div>
          <div className="form-grp">
            <label htmlFor="mobile">Mobile No</label>
            <input
              type="tel"
              id="mobile"
              placeholder="Mobile No"
              onChange={(e) =>
                setFormData({ ...formData, mobile_no: e.target.value })
              }
            />
            <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.mobile_no}</span>
          </div>
       <div className="form-grp">
  <label htmlFor="program">Program</label>
  {programData?.program ? (
    <input
      type="text"
      className="form-control"
      value={programData.program.name}
      disabled
    />
  ) : (
    <p className="text-muted">Loading...</p>
  )}
</div>

          <button type="submit" className="btn rounded mt-3">
            Enroll Now
          </button>
        </form>
      </div>
    </div>
              </div>
            </div>
          </section>

          {/* Steps Section */}
          <section className="py-5">
            <div className="container">
              <h2 className="text-center mb-5 fw-bold">Your Learning Journey Steps</h2>
              {steps.map((step, index) => (
                <motion.div
                  key={step.num}
                  className="row mb-5 align-items-center justify-content-center"
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: index * 0.3 }}
                  viewport={{ once: true }}
                >
                  <div className={`col-md-5 ${index % 2 === 1 ? "order-md-2" : ""}`}>
                    <div className="event__thumb-four">
                      <img
                        src={`/images/ui/programe-step/${step.img}`}
                        alt="step"
                        className="w-100 object-fit-cover"
                        style={{ maxHeight: "400px" }}
                      />
                    </div>
                  </div>
                  <div className={`col-md-5 ${index % 2 === 1 ? "order-md-1" : ""}`}>
                    <div className="event__content-four text-center">
                      <span className="event__date event__date-two text-white mb-3 d-inline-flex">
                        <span className="step_count">{step.num}</span> {step.title}
                      </span>
                      <h2 className="title mb-3">{step.heading}</h2>
                      <p>{step.content}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </section>
        </div>
      }
    />
  );
};

export default ProgramDetailsPage;
